import { Inject, Injectable, OnDestroy, Optional, SkipSelf } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subject, Observable, Subscription, of, interval, forkJoin } from 'rxjs';
import { mergeMap, timeout } from 'rxjs/operators';

import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';

import { DataChange } from '../entities/data-change.entity';

@Injectable({ providedIn: 'root' })
export class CachedDataSurveyService implements OnDestroy {
	private path!: string;
	
	private timeSubscription!: Subscription;
	private notificationsSubjects = new Map<string, Subject<Date>>();
	
	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(JSR310ConversionService) conversionService: JSR310ConversionService, //
		@Optional() @SkipSelf() previousInstance?: CachedDataSurveyService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;

		this.timeSubscription = interval(5000)
			.pipe(
				mergeMap(
					(activationCount) => {
						// console.log("TEST LOG - activation #" + activationCount + " " + new Date() + " - calling serveur data");
						return forkJoin({
							count: of(activationCount),
							changes: this.getChangesFromServer().pipe(
								timeout(3000)
							)
						})
					}
				)
			)
			.subscribe({
				next: (data) => {
					let dataChanges = data.changes;
					
					// let activationCount = data.count;
					// console.log("TEST LOG - activation #" + activationCount + " " + new Date() + " - server answered: " + dataChanges.length + " changes");
					
					// let count = 0;
					for (let dataChange of dataChanges) {
						let subject = this.notificationsSubjects.get(dataChange.key);
						if (subject != undefined) {
							let date = conversionService.fromMandatoryLocalDateTime(dataChange.timestamp);
							subject.next(date);
							// count++;
						}
					}
					
					// console.log("TEST LOG - activation #" + activationCount + " " + new Date() + " - notified " + count + " subscribers");
				},
				error: (errorData) => {
					console.error("CachedDataSurvey - " + new Date() + " - ERROR!", errorData);
				}
			})
		;
	}
	
	ngOnDestroy() {
		this.timeSubscription.unsubscribe();
	}
	
	public getChangeNotification(key: string): Observable<Date> {
		let subject = this.notificationsSubjects.get(key);
		if (subject != undefined) {
			return subject;
		}
			
		subject = new Subject<Date>();
		this.notificationsSubjects.set(key, subject);
		return subject;
	}
	
	public notifyImmediateChange(key: string) {
		let subject = this.notificationsSubjects.get(key);
		if (subject != undefined) {
			subject.next(new Date());
		}
	}
	
	private getChangesFromServer(): Observable<DataChange[]> {
		let url = this.path + "/history/last-changes";
		
		// On ajoute un header special pour empecher l'intercepteur d'afficher un indicateur de chargement
		let headers = new HttpHeaders().set("no-pending-trace", "true");
		
		return this.httpClient //
				.get<DataChange[]>(url, { headers: headers }) //
		;		
	}
	
}